var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3644",
    "data-name": "Group 3644",
    transform: "translate(-981 -2944)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_181",
    "data-name": "Ellipse 181",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(981 2944)",
    fill: "rgba(196,183,0,0.53)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "interface-ui-web-view-app-svgrepo-com",
    transform: "translate(989.753 2952.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10693",
    "data-name": "Path 10693",
    d: "M25.656,4H4.839A2.788,2.788,0,0,0,2,6.839V23.871A2.788,2.788,0,0,0,4.839,26.71H25.656a2.788,2.788,0,0,0,2.839-2.839V6.839A2.788,2.788,0,0,0,25.656,4Zm-14.1,3.406c.095-.095.095-.189.189-.284a.915.915,0,0,1,1.325,0c.095.095.189.189.189.284a.569.569,0,0,1,.095.378.569.569,0,0,1-.095.378c-.095.095-.095.189-.189.284a.859.859,0,0,1-.662.284.569.569,0,0,1-.378-.095c-.095-.095-.189-.095-.284-.189s-.189-.189-.189-.284a.569.569,0,0,1-.095-.378A.569.569,0,0,1,11.557,7.406Zm-2.839,0c.095-.095.095-.189.189-.284s.189-.189.284-.189a.864.864,0,0,1,1.041.189c.095.095.189.189.189.284a.569.569,0,0,1,.095.378.97.97,0,0,1-.946.946.97.97,0,0,1-.946-.946A.569.569,0,0,1,8.718,7.406ZM6.069,7.123l.095-.095c.095,0,.095-.095.189-.095.095-.095.095-.095.189-.095H6.92c.095,0,.095,0,.189.095.095,0,.095.095.189.095l.095.095c.095.095.189.189.189.284a.569.569,0,0,1,.095.378.569.569,0,0,1-.095.378c0,.095-.095.189-.189.284a.915.915,0,0,1-1.325,0,.915.915,0,0,1,0-1.325ZM26.6,23.871a.894.894,0,0,1-.946.946H4.839a.894.894,0,0,1-.946-.946V11.57H26.6Z",
    fill: "#a49a0e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3101",
    "data-name": "Group 3101",
    transform: "translate(9.57 12.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10694",
    "data-name": "Path 10694",
    d: "M15.662,13A19.138,19.138,0,0,0,15,18.677a23.015,23.015,0,0,0,.662,5.677h.568a19.138,19.138,0,0,0,.662-5.677A23.015,23.015,0,0,0,16.23,13h-.568Z",
    transform: "translate(-10.269 -13)",
    fill: "#a49a0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10695",
    "data-name": "Path 10695",
    d: "M18.5,13.5a25,25,0,0,1,.473,5.2,25,25,0,0,1-.473,5.2,5.56,5.56,0,0,0,3.312-5.2A5.658,5.658,0,0,0,18.5,13.5Z",
    transform: "translate(-10.457 -13.027)",
    fill: "#a49a0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10696",
    "data-name": "Path 10696",
    d: "M12.839,18.7a25,25,0,0,1,.473-5.2A5.56,5.56,0,0,0,10,18.7a5.658,5.658,0,0,0,3.312,5.2A25,25,0,0,1,12.839,18.7Z",
    transform: "translate(-10 -13.027)",
    fill: "#a49a0e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodding);
export default __webpack_public_path__ + "static/media/codding.49e303310ab13ed07b2896ec1ad05ee9.svg";
export { ForwardRef as ReactComponent };